<template>
  <div class="checkout-page ahrs-home-bg">
    <div class="page-header">
      <div class="header-background"></div>
      <div class="header-content">
        <h1 class="page-title" data-aos="fade-down">Registration Checkout</h1>
        <p class="page-subtitle" data-aos="fade-up" data-aos-delay="200">
          Complete your registration for AHRS 2026
        </p>
      </div>
    </div>

    <div class="checkout-container">
      <!-- Progress Steps -->
      <div class="progress-steps" data-aos="fade-up">
        <div class="step completed">
          <div class="step-number">1</div>
          <span class="step-label">Package Selection</span>
        </div>
        <div class="step active">
          <div class="step-number">2</div>
          <span class="step-label">Billing Details</span>
        </div>
        <div class="step">
          <div class="step-number">3</div>
          <span class="step-label">Upload Documents</span>
        </div>
      </div>

      <div class="checkout-content">
        <!-- Billing Details Form -->
        <div class="billing-form-container" data-aos="fade-right">
          <div class="billing-form">
            <h2 class="form-title">Billing details</h2>

            <form @submit.prevent="proceedToPayment">
              <div class="form-row">
                <div class="form-group">
                  <label for="firstName" class="form-label">
                    First name <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    v-model="billingDetails.firstName"
                    required
                    class="form-input"
                  />
                </div>
                <div class="form-group">
                  <label for="lastName" class="form-label">
                    Last name <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    v-model="billingDetails.lastName"
                    required
                    class="form-input"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="email" class="form-label">
                  Email address <span class="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  v-model="billingDetails.email"
                  required
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label for="phone" class="form-label">
                  Phone Number <span class="required">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  v-model="billingDetails.phone"
                  placeholder="eg. (+233) 504 230 556 / (+1) 347 384 7817"
                  required
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label for="company" class="form-label">
                  Company <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="company"
                  v-model="billingDetails.company"
                  placeholder="Type company name"
                  required
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label for="position" class="form-label">Position</label>
                <input
                  type="text"
                  id="position"
                  v-model="billingDetails.position"
                  placeholder="Position"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label for="country" class="form-label">
                  Country / Region <span class="required">*</span>
                </label>
                <select
                  id="country"
                  v-model="billingDetails.country"
                  required
                  class="form-select"
                >
                  <option value="">Select Country</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="South Africa">South Africa</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Egypt">Egypt</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Algeria">Algeria</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Libya">Libya</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Angola">Angola</option>
                  <option value="Democratic Republic of Congo">
                    Democratic Republic of Congo
                  </option>
                  <option value="Republic of Congo">Republic of Congo</option>
                  <option value="Central African Republic">
                    Central African Republic
                  </option>
                  <option value="Chad">Chad</option>
                  <option value="Niger">Niger</option>
                  <option value="Mali">Mali</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Ivory Coast">Ivory Coast</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Togo">Togo</option>
                  <option value="Benin">Benin</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Gabon">Gabon</option>
                  <option value="United States">United States</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Canada">Canada</option>
                  <option value="Australia">Australia</option>
                  <option value="Germany">Germany</option>
                  <option value="France">France</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Norway">Norway</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Finland">Finland</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div class="form-group">
                <label for="city" class="form-label">
                  Town / City <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  v-model="billingDetails.city"
                  required
                  class="form-input"
                />
              </div>

              <!-- Policy Agreement -->
              <div class="form-group policy-agreement">
                <div class="checkbox-container">
                  <input
                    type="checkbox"
                    id="policyAgreement"
                    v-model="agreedToPolicy"
                    @change="handlePolicyChange"
                    required
                    class="policy-checkbox"
                  />
                  <label for="policyAgreement" class="policy-label">
                    I agree to the
                    <a href="#" class="policy-link">Terms and Conditions</a>
                    and
                    <a href="#" class="policy-link">Privacy Policy</a>
                    <span class="required">*</span>
                    <span v-if="isDraftSaving" class="draft-saving">
                      <span class="small-spinner"></span>
                      Saving...
                    </span>
                  </label>
                </div>
              </div>

              <!-- Error trigger is now handled by the modal below -->

              <div class="form-actions">
                <button type="button" @click="goBack" class="back-btn" :disabled="isSubmitting">
                  Back to cart
                </button>
                <button
                  type="submit"
                  :disabled="!agreedToPolicy || isSubmitting"
                  class="next-btn"
                  :class="{ disabled: !agreedToPolicy || isSubmitting }"
                >
                  <span v-if="isSubmitting" class="loading-spinner"></span>
                  {{ isSubmitting ? 'Processing...' : 'Next' }}
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Order Summary Sidebar -->
        <div class="order-summary-container" data-aos="fade-left">
          <div class="order-summary">
            <h3 class="summary-title">Order Summary</h3>

            <div class="order-items">
              <div class="order-item">
                <div class="item-details">
                  <h4>
                    {{ checkoutData?.pricing?.title || "Package Registration" }}
                  </h4>
                  <p class="item-subtitle">
                    {{
                      checkoutData?.pricing?.description ||
                      "Conference Registration"
                    }}
                  </p>
                </div>
              </div>

              <div class="selected-packages">
                <div class="package-item">
                  <span class="package-name">✓ Participation</span>
                  <span class="package-price">{{
                    formatPrice(
                      checkoutData?.pricing?.participation?.price || 0
                    )
                  }}</span>
                </div>
                <div v-if="checkoutData?.packages?.tour" class="package-item">
                  <span class="package-name">✓ Tour Package</span>
                  <span class="package-price">{{
                    formatPrice(checkoutData?.pricing?.tourPackage?.price || 0)
                  }}</span>
                </div>
                <div
                  v-if="checkoutData?.packages?.masterclass"
                  class="package-item"
                >
                  <span class="package-name">✓ Masterclass</span>
                  <span class="package-price">{{
                    formatPrice(checkoutData?.pricing?.masterclass?.price || 0)
                  }}</span>
                </div>
              </div>
            </div>

            <div class="order-totals">
              <div class="total-row subtotal">
                <span>Subtotal</span>
                <span>{{ formatPrice(checkoutData?.total || 0) }}</span>
              </div>
              <div class="total-row final-total">
                <span>Total</span>
                <span>{{ formatPrice(checkoutData?.total || 0) }}</span>
              </div>
            </div>

            <div class="event-info">
              <h4>Payment Information</h4>
              <div class="info-item">
                <strong>Payment Methods:</strong>
              </div>
              <ul class="payment-methods-list">
                <li>PayPal/VISA</li>
                <li>Bank Transfer</li>
                <li>Mobile Money</li>
              </ul>
              <div class="bank-transfer-details">
                <strong>Bank Transfer Details</strong>
                <div class="info-item"><strong>Bank:</strong> CRDB Bank</div>
                <div class="info-item"><strong>Branch:</strong> Temeke Taifa</div>
                <div class="info-item"><strong>Account Name:</strong> Tanzania Human Resource and Administration Professionals Association</div>
                <div class="info-item"><strong>Account (USD):</strong> 10152775817</div>
                <div class="info-item"><strong>Account (TZS):</strong> 015C955976800</div>
                <div class="info-item"><strong>Branch Code:</strong> 048161</div>
                <div class="info-item"><strong>Swift Code:</strong> CORUTZTZ</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Modal -->
  <Teleport to="body">
    <div v-if="showErrorModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-box">
        <div class="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="modal-title">Registration Failed</h3>
        <p class="modal-message">{{ submitError }}</p>
        <button class="modal-close-btn" @click="closeModal">OK</button>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { registrationAPI } from "@/services/api";

const router = useRouter();

const checkoutData = ref(null);

const billingDetails = ref({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  company: "",
  position: "",
  country: "",
  city: "",
});

const agreedToPolicy = ref(false);
const isSubmitting = ref(false);
const submitError = ref(null);
const showErrorModal = ref(false);
const isDraftSaving = ref(false);

const closeModal = () => {
  showErrorModal.value = false;
};

onMounted(() => {
  // Get checkout data from sessionStorage
  const storedData = sessionStorage.getItem("checkoutData");
  if (storedData) {
    checkoutData.value = JSON.parse(storedData);

    // Load existing billing details if they exist
    if (checkoutData.value.billingDetails) {
      billingDetails.value = { ...checkoutData.value.billingDetails };
    }

    // Load existing policy agreement state if it exists
    if (checkoutData.value.agreedToPolicy !== undefined) {
      agreedToPolicy.value = checkoutData.value.agreedToPolicy;
    }
  } else {
    // If no checkout data, redirect back to join us page
    router.push("/registration");
  }
});

const formatPrice = (price) => {
  if (!price || !checkoutData.value?.pricing) return "";

  if (checkoutData.value.pricing.currency === "TZS") {
    return `TZS ${price.toLocaleString()}`;
  } else {
    return `USD ${price.toLocaleString()}`;
  }
};

const goBack = () => {
  router.push("/registration");
};

// Handle checkbox change to save draft
const handlePolicyChange = async () => {
  if (agreedToPolicy.value && billingDetails.value.email) {
    isDraftSaving.value = true;

    try {
      const draftData = {
        billingDetails: billingDetails.value,
        packages: checkoutData.value?.packages,
        pricing: checkoutData.value?.pricing,
        total: checkoutData.value?.total,
        membershipCategory: checkoutData.value?.category
      };

      const response = await registrationAPI.saveDraft(draftData);
      console.log('Draft saved:', response.message);

    } catch (error) {
      console.warn('Failed to save draft:', error);
      // Don't show error to user - this is just a background save
    } finally {
      isDraftSaving.value = false;
    }
  }
};

const proceedToPayment = async () => {
  if (isSubmitting.value) return;

  isSubmitting.value = true;
  submitError.value = null;

  try {
    // Store billing details and proceed to payment
    const fullCheckoutData = {
      ...checkoutData.value,
      billingDetails: billingDetails.value,
      agreedToPolicy: agreedToPolicy.value,
    };

    // Save to backend
    const registrationData = {
      billingDetails: billingDetails.value,
      packages: checkoutData.value.packages,
      pricing: checkoutData.value.pricing,
      total: checkoutData.value.total,
      agreedToPolicy: agreedToPolicy.value,
      membershipCategory: checkoutData.value.category
    };

    try {
      const response = await registrationAPI.saveRegistration(registrationData);

      // Add the registration ID to checkout data
      fullCheckoutData.registrationId = response.registrationId;

      console.log('Registration saved with ID:', response.registrationId);
    } catch (apiError) {
      console.warn('Failed to save registration to backend:', apiError);
      submitError.value = apiError.error || apiError.message || 'Failed to save registration. Please try again.';
      showErrorModal.value = true;
      isSubmitting.value = false;
      return; // Stop — do not proceed to payment on error
    }

    // Save to sessionStorage for UX continuity
    sessionStorage.setItem("checkoutData", JSON.stringify(fullCheckoutData));

    router.push("/documents");

  } catch (error) {
    console.error('Error in proceedToPayment:', error);
    submitError.value = 'An error occurred while processing your request';
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
.checkout-page {
  min-height: 100vh;
  color: #fbf7ec;
  padding-top: 80px;
}

.page-header {
  position: relative;
  text-align: center;
  padding: 40px 20px 30px;
  overflow: hidden;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgba(74, 222, 128, 0.1) 0%,
    transparent 70%
  );
  animation: pulse 4s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(1.05);
  }
}

.header-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.page-title {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 15px;
  color: #fbf7ec;
}

.page-subtitle {
  font-size: 1.2rem;
  color: rgba(251, 247, 236, 0.92);
  letter-spacing: 1px;
}

@keyframes textShimmer {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.checkout-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 30px 20px;
}

.progress-steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  gap: 20px;
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 20px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(74, 222, 128, 0.2);
  transition: all 0.3s ease;
}

.step.completed {
  background: rgba(74, 222, 128, 0.2);
  border-color: #b8f0c8;
}

.step.active {
  background: rgba(74, 222, 128, 0.15);
  border-color: #b8f0c8;
  box-shadow: 0 0 20px rgba(74, 222, 128, 0.3);
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--color-primary-light);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
}

.step-label {
  font-weight: 600;
  color: rgba(251, 247, 236, 0.92);
  white-space: nowrap;
}

.checkout-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
  align-items: start;
}

.billing-form-container {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(74, 222, 128, 0.2);
  border-radius: 20px;
  padding: 40px;
}

.form-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 30px;
  color: #b8f0c8;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: rgba(251, 247, 236, 0.92);
}

.required {
  color: #ef4444;
}

.form-input,
.form-select {
  width: 100%;
  padding: 15px 20px;
  background: rgba(74, 222, 128, 0.1);
  border: 2px solid rgba(74, 222, 128, 0.3);
  border-radius: 12px;
  color: #fbf7ec;
  font-size: 1rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.form-input::placeholder {
  color: rgba(251, 247, 236, 0.65);
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #b8f0c8;
  box-shadow: 0 0 20px rgba(74, 222, 128, 0.3);
}

.form-select option {
  background: #1a472a;
  color: #fbf7ec;
  padding: 10px;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  gap: 20px;
}

.back-btn,
.next-btn {
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.back-btn {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(251, 247, 236, 0.82);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fbf7ec;
}

.next-btn {
  background: linear-gradient(
    135deg,
    var(--color-primary-light),
    var(--color-success)
  );
  color: #fbf7ec;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 0 20px rgba(74, 222, 128, 0.4);
}

.next-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 0 30px rgba(74, 222, 128, 0.6);
}

.next-btn:disabled,
.next-btn.disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(251, 247, 236, 0.65);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.policy-agreement {
  background: rgba(74, 222, 128, 0.05);
  border: 1px solid rgba(74, 222, 128, 0.2);
  border-radius: 12px;
  padding: 20px;
  margin: 25px 0;
}

.checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.policy-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #b8f0c8;
  cursor: pointer;
  margin-top: 2px;
  flex-shrink: 0;
}

.policy-label {
  color: rgba(251, 247, 236, 0.92);
  line-height: 1.5;
  cursor: pointer;
  font-size: 1rem;
}

.policy-link {
  color: #b8f0c8;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.policy-link:hover {
  color: #ffffff;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  color: #fca5a5;
  font-size: 0.9rem;
}

.error-icon {
  width: 20px;
  height: 20px;
  color: #ef4444;
  flex-shrink: 0;
}

.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.draft-saving {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 10px;
  color: #b8f0c8;
  font-size: 0.8rem;
  font-weight: 500;
}

.small-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1.5px solid transparent;
  border-top: 1.5px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.order-summary-container {
  position: sticky;
  top: 100px;
}

.order-summary {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(74, 222, 128, 0.2);
  border-radius: 20px;
  padding: 30px;
}

.summary-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #b8f0c8;
}

.order-items {
  margin-bottom: 25px;
}

.order-item {
  margin-bottom: 20px;
}

.item-details h4 {
  color: #b8f0c8;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 5px;
}

.item-subtitle {
  color: rgba(251, 247, 236, 0.65);
  font-size: 0.9rem;
}

.selected-packages {
  background: rgba(74, 222, 128, 0.08);
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
}

.package-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(74, 222, 128, 0.1);
}

.package-item:last-child {
  border-bottom: none;
}

.package-name {
  color: rgba(251, 247, 236, 0.92);
  font-weight: 500;
}

.package-price {
  color: #b8f0c8;
  font-weight: 700;
}

.order-totals {
  border-top: 2px solid rgba(74, 222, 128, 0.2);
  padding-top: 20px;
  margin-top: 20px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.subtotal {
  color: rgba(251, 247, 236, 0.82);
  font-size: 1rem;
}

.final-total {
  color: #fbf7ec;
  font-size: 1.3rem;
  font-weight: 700;
  border-top: 1px solid rgba(74, 222, 128, 0.2);
  padding-top: 15px;
  margin-top: 10px;
}

.final-total span:last-child {
  color: #b8f0c8;
}

.event-info {
  background: rgba(74, 222, 128, 0.08);
  border-radius: 12px;
  padding: 20px;
  margin-top: 25px;
}

.event-info h4 {
  color: #b8f0c8;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.info-item {
  margin-bottom: 8px;
  color: rgba(251, 247, 236, 0.92);
  line-height: 1.4;
}

.info-item a {
  color: #4ade80;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.info-item a:hover {
  color: #22c55e;
  border-bottom: 1px solid #22c55e;
  text-shadow: 0 0 8px rgba(34, 197, 94, 0.3);
}

.payment-methods-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 16px 0;
}

.payment-methods-list li {
  color: rgba(251, 247, 236, 0.92);
  padding: 4px 0;
  padding-left: 16px;
  position: relative;
  font-size: 0.95rem;
}

.payment-methods-list li::before {
  content: '•';
  color: #b8f0c8;
  position: absolute;
  left: 0;
}

.bank-transfer-details {
  background: rgba(74, 222, 128, 0.05);
  border: 1px solid rgba(74, 222, 128, 0.15);
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
}

.bank-transfer-details > strong {
  display: block;
  color: #b8f0c8;
  font-size: 0.95rem;
  margin-bottom: 10px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .checkout-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .order-summary-container {
    position: relative;
    top: 0;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 2.2rem;
  }

  .progress-steps {
    flex-direction: column;
    gap: 15px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .billing-form-container,
  .order-summary {
    padding: 25px;
  }

  .form-actions {
    flex-direction: column;
    gap: 15px;
  }

  .back-btn,
  .next-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 1.8rem;
  }

  .billing-form-container,
  .order-summary {
    padding: 20px;
  }

  .step-label {
    display: none;
  }
}

/* ── Error Modal ─────────────────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-box {
  background: linear-gradient(135deg, #0f2419, #1a472a);
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: 20px;
  padding: 40px 36px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6), 0 0 30px rgba(239, 68, 68, 0.15);
}

.modal-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 20px;
  color: #ef4444;
}

.modal-icon svg {
  width: 100%;
  height: 100%;
}

.modal-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #fca5a5;
  margin-bottom: 14px;
}

.modal-message {
  color: rgba(251, 247, 236, 0.82);
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 28px;
}

.modal-close-btn {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fbf7ec;
  border: none;
  padding: 12px 40px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
}
</style>
